import styled from 'styled-components'
import DecorateComponent from './decorate'
import LoopTypeComponent from './loop-type'
import NoAnimationComponent from './no-animation'
import TrimComponent from './trim'

export const QuickDecorate = styled(DecorateComponent)`
    grid-column: span 5;
`

export const LoopType = styled(LoopTypeComponent)`
    grid-column: span 3;
`

export const Trim = styled(TrimComponent)`
    grid-column: span 8;
`

export const NoAnimation = styled(NoAnimationComponent)`
    grid-column: span 8;
`
